import { cn } from "@/lib/utils";

interface StrandBadgeProps {
  strand: "physical" | "linguistic" | "cognitive" | "social-emotional";
  className?: string;
}

const strandConfig = {
  physical: {
    label: "Physical",
    emoji: "🏃",
    bgClass: "bg-strand-physical-light text-strand-physical",
  },
  linguistic: {
    label: "Linguistic",
    emoji: "💬",
    bgClass: "bg-strand-linguistic-light text-strand-linguistic",
  },
  cognitive: {
    label: "Cognitive",
    emoji: "🧠",
    bgClass: "bg-strand-cognitive-light text-strand-cognitive",
  },
  "social-emotional": {
    label: "Social & Emotional",
    emoji: "🤝",
    bgClass: "bg-strand-social-emotional-light text-strand-social-emotional",
  },
};

export default function StrandBadge({ strand, className }: StrandBadgeProps) {
  // Backend may send "social_emotional" (underscore) instead of "social-emotional"
  const normalized = strand === "social_emotional" ? "social-emotional" : strand;
  const config = strandConfig[normalized as keyof typeof strandConfig];

  if (!config) {
    return (
      <span className={cn("inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600", className)}>
        {strand}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium",
        config.bgClass,
        className
      )}
    >
      {config.emoji} {config.label}
    </span>
  );
}
